import { render, staticRenderFns } from "./NotServiceOldReason.vue?vue&type=template&id=7853ec80&scoped=true"
import script from "./NotServiceOldReason.vue?vue&type=script&lang=js"
export * from "./NotServiceOldReason.vue?vue&type=script&lang=js"
import style0 from "./NotServiceOldReason.vue?vue&type=style&index=0&id=7853ec80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7853ec80",
  null
  
)

export default component.exports